// @generated by protoc-gen-connect-query v2.2.0 with parameter "target=ts"
// @generated from file bffuser/v1/company_info_service.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import { CompanyInfoService } from "./company_info_service_pb";

/**
 * GetCompanyInfo returns the organization's company info. company_info is
 * unset when not registered (= 未登録; the frontend disables the emission
 * factor linking UI and shows the unregistered hint per AC-BSP-087).
 *
 * @generated from rpc bffuser.v1.CompanyInfoService.GetCompanyInfo
 */
export const getCompanyInfo = CompanyInfoService.method.getCompanyInfo;
